import {
  IonCol,
  IonContent,
  IonLoading,
  IonPage,
  IonRow,
  useIonRouter,
} from '@ionic/react'
import { useLocation } from 'react-router-dom'
import { parsePhoneNumberFromString } from 'libphonenumber-js'

import { useAccount } from '../../../contexts/authContext'
import { useToast } from '../../../contexts/toastContext'
import { useOptInClient } from '../../../marketing/customer-opt-in/mutations'
import { PhoneKeypadInput } from '../../../components/ui/phone-keypad-input'
import { RotateInfoContainer } from '../../../rotate/rotate-info-container'
import { RotateInfoIntro } from '../../../rotate/rotate-info-intro'
import { RotateInfoLegal } from '../../../rotate/rotate-info-legal'

import type { CountryCode } from 'libphonenumber-js'

function CustomerOptInPage() {
  return (
    <IonPage>
      <IonContent className="ion-padding-horizontal">
        <CustomerOptIn />
      </IonContent>
    </IonPage>
  )
}

function CustomerOptIn() {
  const account = useAccount()
  const router = useIonRouter()
  const location = useLocation()
  const searchParams = new URLSearchParams(location.search)

  const setToast = useToast()

  const optInClient = useOptInClient()

  function handleSignUp({
    phoneNumber,
    country,
  }: {
    phoneNumber: string
    country: CountryCode
  }) {
    const parsedNumber = parsePhoneNumberFromString(phoneNumber, country)

    if (!parsedNumber?.number)
      return setToast({
        message: 'You have entered an invalid phone number.',
        color: 'danger',
      })

    optInClient.mutate(parsedNumber.number, {
      onSuccess: ({ client }) => {
        searchParams.append('clientId', client.objectId)

        if (client.firstName || client.lastName)
          router.push(
            `/admin/customer/opt-in/success?${searchParams}`,
            'none',
            'replace'
          )
        else
          router.push(
            `/admin/customer/opt-in/more-info?${searchParams}`,
            'none',
            'replace'
          )
      },
    })
  }

  return (
    <>
      <IonRow className="h-full">
        <IonCol
          size="6"
          className="flex h-full flex-1 flex-col items-center justify-center space-y-6"
        >
          <RotateInfoContainer>
            <div className="text-center">
              <RotateInfoIntro>
                Welcome to {account.account.companyName}.
              </RotateInfoIntro>
              <RotateInfoIntro>
                Enter your phone number to join our VIP text list!
              </RotateInfoIntro>
            </div>
            <RotateInfoLegal />
          </RotateInfoContainer>
        </IonCol>
        <IonCol
          size="6"
          className="flex h-full flex-1 flex-col items-center justify-center gap-6"
        >
          <PhoneKeypadInput onConfirm={handleSignUp} />
        </IonCol>
      </IonRow>

      <IonLoading
        isOpen={optInClient.isLoading}
        message="Thanks! We're signing you up!"
      />
    </>
  )
}

export default CustomerOptInPage
